import { fetchAPI } from '../utils/api';
import { getLocale } from '../utils/intl';

export const updateLanguage = (locale: string) => {
  return fetchAPI('/versions', {
    headers: {
      'Accept-Language': locale,
    },
  });
};

export const updateLanguageByLocale = () => updateLanguage(getLocale());

export const checkUserRedirectToDashboard = () =>
  fetchAPI('/users/popup/check?popup_key=MY_DATA_PAGE_V2.8', {
    method: 'GET',
    version: '1.2',
  });

export const submitUserRedirectToDashboard = () =>
  fetchAPI('/users/popup/check', {
    method: 'POST',
    version: '1.2',
    payload: {
      popup_key: 'MY_DATA_PAGE_V2.8',
      platform: 'web',
    },
  });



// WEBPACK FOOTER //
// ./app/api/user.ts